import { Plus } from "lucide-react";
import { Input } from "../../../components/ui/input";
import { Label } from "../../../components/ui/label";
import UploadButton from "../../../components/admin/UploadButton";

const uid = () => (crypto.randomUUID ? crypto.randomUUID() : `id-${Date.now()}`);

export default function TransformationsTab({ content, patchItem, removeItem, patchList, Card }) {
  return (
    <>
      <p className="text-sm text-stone-500">Each pair becomes a draggable before-and-after slider on the site. Upload photos or paste image URLs. Photos are shown in a 4:3 frame (centered) on the site — upload similar shots for the cleanest comparison.</p>
      <div className="mt-6 grid gap-5 lg:grid-cols-2">
        {content.transformations.map((t, i) => (
          <Card key={t.id} testid={`ba-editor-${i}`} onDelete={() => removeItem("transformations", t.id)}>
            <Label>Label</Label>
            <Input className="mt-1.5" value={t.label} onChange={(e) => patchItem("transformations", t.id, { label: e.target.value })} data-testid={`ba-label-input-${i}`} placeholder="Poodle glow-up" />
            <div className="mt-4 grid gap-4 sm:grid-cols-2">
              {["beforeUrl", "afterUrl"].map((key) => (
                <div key={key}>
                  <div className="mb-2 aspect-[4/3] overflow-hidden rounded-2xl bg-lavender-100">
                    {t[key] && <img src={t[key]} alt="" className="h-full w-full object-cover object-center" />}
                  </div>
                  <Label>{key === "beforeUrl" ? "Before" : "After"}</Label>
                  <Input className="mt-1.5" value={t[key]} onChange={(e) => patchItem("transformations", t.id, { [key]: e.target.value })} data-testid={`ba-${key}-input-${i}`} placeholder="https://…" />
                  <div className="mt-2">
                    <UploadButton testid={`ba-${key}-upload-${i}`} label={`Upload ${key === "beforeUrl" ? "before" : "after"}`} onUploaded={(url) => patchItem("transformations", t.id, { [key]: url })} />
                  </div>
                </div>
              ))}
            </div>
          </Card>
        ))}
      </div>
      <button
        onClick={() => patchList("transformations", [...content.transformations, { id: uid(), label: "", beforeUrl: "", afterUrl: "" }])}
        data-testid="add-ba-button"
        className="mt-6 inline-flex items-center gap-2 rounded-full border-2 border-dashed border-lavender-300 px-6 py-3 text-sm font-semibold text-lavender-700 transition-colors hover:border-lavender-500 hover:bg-lavender-100"
      >
        <Plus size={16} /> Add before & after
      </button>
    </>
  );
}
